import React from "react"
import { MainCP } from "../../Components/intencion-voto/MainCP"

const ViewIntencionVoto: React.FC = () => <MainCP/>

export default ViewIntencionVoto